export default __webpack_public_path__ + "static/media/icon-coin-dot.4d576187.svg";